module.exports = __webpack_public_path__ + "static/media/fly0260.f535cc68.webp";